<div class="modal fade" id="{{moveSplitFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Move-Split Dispatch</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Dispatch Header -->
            <div class="bg-primary border-bottom border-primary-subtle px-3 py-1" style="--bs-bg-opacity: .2;">
                <div class="row g-1 mb-1">
                    <div class="col-sm-4">
                        <label for="dispatchCustomer" class="form-label"> {{ schedule.locationType === 0 ? 'Destination' : 'Origin' }} Customer </label>
                        <input type="text" class="form-control form-control-sm" id="dispatchCustomer" disabled value="{{dispatch.customer.customerName}}" />
                    </div>
                    <div class="col-sm-5">
                        <label for="dispatchLocation" class="form-label"> {{ schedule.locationType === 0 ? 'Destination' : 'Origin' }} </label>
                        <input type="text" class="form-control form-control-sm" id="dispatchLocation" disabled value="{{dispatch.location.locationName}}" />
                    </div>
                    <div class="col-sm-3">
                        <label for="dispatchLocatonCity" class="form-label">City</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchLocatonCity" disabled value="{{dispatch.location.city}}" />
                    </div>
                </div>
                <div class="row g-1 mb-1">
                    <div class="col-sm-4">
                        <label for="dispatchTrucker" class="form-label">Trucker</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchTrucker" disabled value="{{dispatch.trucker.customerName}}" />
                    </div>              
                    <div class="col-sm-3">
                        <label for="dispatchLoads" class="form-label">Loads</label>
                        <input type="text" class="form-control form-control-sm" id="dispatchLoads" disabled value="{{dispatch.loads}}" />
                    </div>  
                </div>
            </div>

            <!-- Modal Body -->
            <div class="modal-body" style="min-height: 400px;">
                <div class="container-fluid">

                    <!-- Schedule Selection -->
                    <div #scheduleSearchDropdown class="border rounded p-1 mt-1 mb-3">
                        <label class="form-label">Move/Split to Schedule</label>
                        <div class="row g-1">
                            <div class="col-sm-3">
                                <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleScheduleSearch()">
                                    Select Schedule
                                </button>                              

                                <!-- Schedule Dropdown -->
                                <div *ngIf="showScheduleSearch">
                                    <div class="dropdown-search table-responsive border rounded shadow px-2">
                                        <table class="table table-sm table-borderless table-hover scrollable">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Customer
                                                        <input type="text" class="form-control form-control-sm" id="searchCustomer" name="searchCustomer" [(ngModel)]="searchCustomer" (ngModelChange)="filterMoveSplitScheduleList()" />
                                                    </th>
                                                    <th>
                                                        {{schedule.locationType === 1 ? 'Destination' : 'Origin' }}
                                                        <input type="text" class="form-control form-control-sm" id="searchName" name="searchName" [(ngModel)]="searchName" (ngModelChange)="filterMoveSplitScheduleList()" />
                                                    </th>
                                                    <th>
                                                        City
                                                        <input type="text" class="form-control form-control-sm" id="searchCity" name="searchCity" [(ngModel)]="searchCity" (ngModelChange)="filterMoveSplitScheduleList()" />
                                                    </th>
                                                    <th> F/D </th>
                                                    <th> Loads </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="moveSplitScheduleList.length > 0; else noRecords">
                                                    <tr *ngFor="let item of filteredMoveSplitScheduleList" (click)="selectMoveSplitSchedule(item)">
                                                        <td>{{item.customerName}}</td>
                                                        <td>{{item.locationName}}</td>
                                                        <td>{{item.locationCity}}</td>
                                                        <td>{{item.deliveryTerm}}</td>
                                                        <td>{{item.loads}}</td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                        <ng-template #noRecords>
                                            <tr>
                                                <td colspan="5" class="text-center text-danger">{{ showErrorText }}</td>
                                            </tr>
                                        </ng-template>
                                    </div>
                                </div>                                
                            </div>
                            <div class="col-sm-7">
                                <div class="row g-1">
                                    <div class="col-5">
                                        <select name="planPeriod" class="form-select form-select-sm" [(ngModel)]="moveSplitDispatchFormParams.planPeriod" (change)="planPeriodChange()">
                                            <option *ngFor="let item of planPeriods; trackBy: trackPlanPeriod" [value]="item.value">{{ item.text }}</option>
                                        </select>
                                    </div>
                                    <div class="col-7">
                                        <div class="row g-1">
                                            <div class="col-6">
                                                <input type="date" class="form-control form-control-sm" disabled [(ngModel)]="moveSplitDispatchFormParams.periodStartDate" [ngModelOptions]="{standalone: true}" [attr.disabled]="moveSplitDispatchFormParams.planPeriod === 'Custom' ? null : ''">
                                            </div>
                                            <div class="col-6">
                                                <input type="date" class="form-control form-control-sm" disabled [(ngModel)]="moveSplitDispatchFormParams.periodEndDate" [ngModelOptions]="{standalone: true}" [attr.disabled]="moveSplitDispatchFormParams.planPeriod === 'Custom' ? null : ''">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2 d-grid">
                                <button class="btn btn-sm btn-primary" (click)="searchScheduleMoveListItems()">Search</button>
                            </div>
                        </div>

                        <!-- Selected Schedule Preview -->
                        <div class="row g-1 mb-1">
                            <div class="col-sm-4">
                                <label class="form-label">Customer</label>
                                <input type="text" class="form-control form-control-sm" disabled value="{{selectedMoveSplitSchedule?.customerName}}" />
                            </div>
                            <div class="col-sm-5">
                                <label class="form-label">{{dispatchLocationType}}</label>
                                <input type="text" class="form-control form-control-sm" disabled value="{{selectedMoveSplitSchedule?.locationName}}" />
                            </div>
                            <div class="col-sm-3">
                                <label class="form-label">City</label>
                                <input type="text" class="form-control form-control-sm" disabled value="{{selectedMoveSplitSchedule?.locationCity}}" />
                            </div>
                        </div>
                        <br />
                    </div>

                    <!-- New Dispatch Info -->
                    <div class="border border-1 p-2 mb-2">
                        <label class="col-form-label-sm">New Dispatch Info</label>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row g-1 mb-2">
                                    <div class="col-4">
                                        <label class="col-form-label-sm">Loads</label>
                                        <input type="number" class="form-control form-control-sm" [disabled]="showErrorText != ''" [(ngModel)]="newDispatchLoads" [ngModelOptions]="{standalone: true}" min="0" max="{{dispatch.loads}}" />
                                    </div>
                                    <div class="col-4">
                                        <label class="col-form-label-sm">Rate</label>
                                        <input type="number" class="form-control form-control-sm" [disabled]="showErrorText != ''" [(ngModel)]="dispatch.rate" [ngModelOptions]="{standalone: true}" />
                                    </div>
                                    <div class="col-4">
                                        <label class="col-form-label-sm">&nbsp;</label>
                                        <select class="form-select form-select-sm" [disabled]="showErrorText != ''" [(ngModel)]="dispatch.rateUnitOfMeasure" [ngModelOptions]="{standalone: true}">
                                            <option *ngFor="let item of uomList" [value]="item.value">{{item.text}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div *ngIf="validNewDispatch.invalid" class="alert alert-danger mt-2">{{validNewDispatch.errorMessage}}</div>

                                <!-- Load/Unload Numbers -->
                                <div *ngIf="schedule.locationType === 1" class="col-sm-4">
                                    <label class="col-form-label-sm">Dest Unload #</label>
                                    <a class="ms-2" href="#" *ngIf="showErrorText == ''" data-bs-toggle="modal" [attr.data-bs-target]="'#' + loadBankApplyFormId" (click)="openLoadBank(1)">
                                        <i class="fa-regular fa-rectangle-list"></i>
                                    </a>
                                    <input type="text" class="form-control form-control-sm" [disabled]="showErrorText != ''" [(ngModel)]="dispatch.unloadNumber" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div *ngIf="schedule.locationType === 0" class="col-sm-4">
                                    <label class="col-form-label-sm">Origin Load #</label>
                                    <a class="ms-2" href="#" *ngIf="showErrorText == ''" data-bs-toggle="modal" [attr.data-bs-target]="'#' + loadBankApplyFormId" (click)="openLoadBank(0)">
                                        <i class="fa-regular fa-rectangle-list"></i>
                                    </a>
                                    <input type="text" class="form-control form-control-sm" [disabled]="showErrorText != ''" [(ngModel)]="dispatch.loadNumber" [ngModelOptions]="{standalone: true}" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label class="col-form-label-sm">Internal Comments</label>
                                <textarea class="form-control" [disabled]="showErrorText != ''" rows="3" [(ngModel)]="dispatch.internalNotes" [ngModelOptions]="{standalone: true}"></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- Daily Loads -->
                    <div class="col-12 mb-2" *ngIf="dispatch.loadBreakoutList.length">
                        <label *ngIf="noLoadSelectedError" class="ms-2 text-danger col-form-label-sm">{{noLoadSelectedError}}</label>
                        <div class="border border-1 p-2">
                            <label class="col-form-label-sm">Daily Loads</label>
                            <div class="col-sm-8 table-responsive load-breakout">
                                <table class="table table-sm table-borderless scrollable">
                                    <thead>
                                        <tr>
                                            <th>{{dispatch.useDeliveryDate ? 'Delivery Date' : 'Load Date'}}</th>
                                            <th>Day</th>
                                            <th>Delivery Time</th>
                                            <th>Original</th>
                                            <th>New</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let loadDay of oldNewDailyLoad.originalLoads; index as i">
                                            <td>
                                                <input type="date" class="form-control form-control-sm" disabled [value]="loadDay.loadDate" />
                                            </td>
                                            <td>
                                                <input type="text" class="form-control form-control-sm" disabled [value]="loadDay.dayOfWeek" />
                                            </td>
                                            <td>
                                                <input type="text" class="form-control form-control-sm" disabled [value]="loadDay.deliveryTime" />
                                            </td>
                                            <td>
                                                <input type="number" class="form-control form-control-sm" readonly [(ngModel)]="oldNewDailyLoad.originalLoads[i].loads" [ngModelOptions]="{standalone: true}" (click)="moveToNew(i)" style="cursor: pointer;" />
                                            </td>
                                            <td>
                                                <input type="number" class="form-control form-control-sm" readonly [(ngModel)]="oldNewDailyLoad.newLoads[i].loads" [ngModelOptions]="{standalone: true}" (click)="moveToOriginal(i)" style="cursor: pointer;" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td class="fw-bold text-end">Total:</td>
                                            <td>
                                                <input type="text" class="form-control form-control-sm fw-bold" disabled [value]="totalOriginal" />
                                            </td>
                                            <td>
                                                <input type="text" class="form-control form-control-sm fw-bold" disabled [value]="totalNew" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!-- Alerts -->
                    <div *ngIf="showAlert" class="alert alert-success mt-2 d-flex justify-content-end">
                        Move/split dispatch saved successfully.
                    </div>
                    <div *ngIf="saveErrorMessage !== ''" class="alert alert-danger mt-2 d-flex justify-content-end">
                        {{saveErrorMessage}}
                    </div>

                    <!-- Footer Buttons -->
                    <div class="d-flex justify-content-end mt-4">
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 80px;" (click)="Save()">Save</button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 80px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Load Bank Modal Component -->
<load-bank-apply [parameters]="loadBankApplyParameters" [loadBankApplyFormId]="loadBankApplyFormId" (loadBankApply)="applyLoadNumber($event)"></load-bank-apply>
